/**
 * Fixed palette of label chip colors. These are persisted as `label.color`
 * (data, not theme tokens), so they live as concrete values in one place rather
 * than being duplicated across the typeahead component and story fixtures.
 */
export const LABEL_COLORS = [
  '#E6B0AA',
  '#F5B7B1',
  '#D7BDE2',
  '#D2B4DE',
  '#A9CCE3',
  '#AED6F1',
  '#A3E4D7',
  '#A2D9CE',
  '#A9DFBF',
  '#ABEBC6',
  '#F9E79F',
  '#FAD7A0',
  '#F5CBA7',
  '#EDBB99',
] as const;

/** Pick a color for a newly created label. */
export function pickRandomLabelColor(): string {
  return LABEL_COLORS[Math.floor(Math.random() * LABEL_COLORS.length)] ?? LABEL_COLORS[0];
}
